import React from "react";
import Chart from "react-apexcharts";

const PlayerGameBar = (props) => {
  // Game Bar chart logic start here
  const dataGoValues = Object.values(props.goRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataGksValues = Object.values(props.gksRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataOgValues = Object.values(props.ogRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataAstValues = Object.values(props.astRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataPiValues = Object.values(props.piRangeData).map((value) =>
    parseInt(value, 10)
  );

  const dataTwValues = Object.values(props.twRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataPsValues = Object.values(props.psRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataPmValues = Object.values(props.pmRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataGcdValues = Object.values(props.gcdRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataYcdValues = Object.values(props.ycdRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataRcdValues = Object.values(props.rcdRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataCstValues = Object.values(props.cstRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataP60Values = Object.values(props.p60RangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataP60PlusValues = Object.values(props.p60PlusRangeData).map((value) =>
    parseInt(value, 10)
  );

  const dataFpValues = Object.values(props.fpsRangeData).map((value) =>
    parseInt(value, 10)
  );
  const formattedGoData = {
    series: [
      {
        name: "Goal Per Match",
        data: dataGoValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Goal Per Match",
        align: "left",
      },
    },
  };

  const formattedGksData = {
    series: [
      {
        name: "Goal Saves Per Match",
        data: dataGksValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Goal Saves Per Match",
        align: "left",
      },
    },
  };

  const formattedOgData = {
    series: [
      {
        name: "Own Goal Per Match",
        data: dataOgValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Own Goal Per Match",
        align: "left",
      },
    },
  };
  const formattedAstData = {
    series: [
      {
        name: "Assists Per Match",
        data: dataAstValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Assists Per Match",
        align: "left",
      },
    },
  };
  const formattedPiData = {
    series: [
      {
        name: "Passes Intercepted Per Match",
        data: dataPiValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Passes Intercepted Per Match",
        align: "left",
      },
    },
  };
  const formattedFpData = {
    series: [
      {
        name: "Fantasy Points Per Match",
        data: dataFpValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1-5",
          "6-10",
          "11-15",
          "16-20",
          "21-30",
          "31-40",
          "41-50",
          "51+",
        ],
      },
      title: {
        text: "Fantasy Points Per Inning",
        align: "left",
      },
    },
  };

  const formattedTwData = {
    series: [
      {
        name: "Tackles Wons Per Match",
        data: dataTwValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Tackles Wons Per Match",
        align: "left",
      },
    },
  };

  const formattedPsData = {
    series: [
      {
        name: "Penalty Saves Per Match",
        data: dataPsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Penalty Saves Per Match",
        align: "left",
      },
    },
  };
  const formattedPmData = {
    series: [
      {
        name: "Penalty Miss Per Match",
        data: dataPmValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Penalty Miss Per Match",
        align: "left",
      },
    },
  };
  const formattedGcdData = {
    series: [
      {
        name: "Green Card Per Match",
        data: dataGcdValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Green Card Per Match",
        align: "left",
      },
    },
  };
  const formattedYcdData = {
    series: [
      {
        name: "Yellow Card Per Match",
        data: dataYcdValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Yellow Card Per Match",
        align: "left",
      },
    },
  };
  const formattedRcdData = {
    series: [
      {
        name: "Red Card Per Match",
        data: dataRcdValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Red Card Per Match",
        align: "left",
      },
    },
  };
  const formattedCstData = {
    series: [
      {
        name: "Clean Sheet Per Match",
        data: dataCstValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Clean Sheet Per Match",
        align: "left",
      },
    },
  };
  const formattedP60Data = {
    series: [
      {
        name: "Played 60mins Per Match",
        data: dataP60Values,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Played 60mins Per Match",
        align: "left",
      },
    },
  };

  const formattedP60PlusData = {
    series: [
      {
        name: "Played 60+mins Per Match",
        data: dataP60PlusValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "6", "6", "7", "8"],
      },
      title: {
        text: "Played 60+mins Per Match",
        align: "left",
      },
    },
  };
  // Game Bar chart logic start here
  return (
    <>
      <ul className="sponsor_list bonus-card">
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedGoData.chartOptions}
              series={formattedGoData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedGksData.chartOptions}
              series={formattedGksData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedOgData.chartOptions}
              series={formattedOgData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedAstData.chartOptions}
              series={formattedAstData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedPsData.chartOptions}
              series={formattedPsData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedPmData.chartOptions}
              series={formattedPmData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedGcdData.chartOptions}
              series={formattedGcdData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedYcdData.chartOptions}
              series={formattedYcdData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedRcdData.chartOptions}
              series={formattedRcdData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedCstData.chartOptions}
              series={formattedCstData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedP60Data.chartOptions}
              series={formattedP60Data.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedP60PlusData.chartOptions}
              series={formattedP60PlusData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedFpData.chartOptions}
              series={formattedFpData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
      </ul>
    </>
  );
};

export default PlayerGameBar;
